import type { Preferences } from '../../../core/ports/preferences-repository';
import { validateGraphAppearanceConfig } from '../../../core/policies/archive/validate-archive';
import type { GraphAppearanceConfig } from '../../../core/entities/graph-appearance-config';
import { LocalStoragePreferencesRepository } from '../../../storage/implementations/localstorage-preferences-repository';

const preferencesRepository = new LocalStoragePreferencesRepository();

export async function loadStoredGraphAppearanceConfig(graphId: string): Promise<GraphAppearanceConfig> {
	const graphAppearanceByGraphId = await preferencesRepository.get('graphAppearanceByGraphId');
	const rawConfig = isGraphAppearanceMap(graphAppearanceByGraphId)
		? graphAppearanceByGraphId[graphId]
		: undefined;

	return validateGraphAppearanceConfig(
		rawConfig ? { graphAppearanceConfig: rawConfig } : undefined,
	).config;
}

export async function saveStoredGraphAppearanceConfig(graphId: string, config: GraphAppearanceConfig): Promise<void> {
	const graphAppearanceByGraphId = await preferencesRepository.get('graphAppearanceByGraphId');
	const currentMap = isGraphAppearanceMap(graphAppearanceByGraphId)
		? graphAppearanceByGraphId
		: {};

	await preferencesRepository.set('graphAppearanceByGraphId', {
		...currentMap,
		[graphId]: config,
	} satisfies Preferences['graphAppearanceByGraphId']);
}

function isGraphAppearanceMap(
	value: Preferences['graphAppearanceByGraphId'] | undefined,
): value is NonNullable<Preferences['graphAppearanceByGraphId']> {
	return !!value && typeof value === 'object' && !Array.isArray(value);
}